<template>
  <section id="sl-meals" class="master-section">
    <header>
      <h1 class="title">Meals</h1>
      <router-link :to="{name: 'meal-create'}" class="btn btn-primary"><fa-icon icon="plus-circle"></fa-icon></router-link>
      <button v-if="editorOpen" @click.stop="closeEditor" class="btn btn-link"><fa-icon icon="arrow-left"></fa-icon><span>Meal List</span></button>
    </header>
    <template v-if="mealsAreLoaded && itemsAreLoaded">
      <meal-ingredient-picker v-if="editorOpen && pickerMeal.id" :meal="pickerMeal" @done="closeEditor"></meal-ingredient-picker>
      <div v-else class="cards">
        <div class="card meal" v-for="meal in meals" :key="meal.id">
          <div class="card-header">
            <div class="card-title h4">{{ meal.name }}</div>
            <router-link :to="{ name: 'meal-edit', params: {id: `${meal.id}`}}" class="btn btn-secondary"><fa-icon icon="edit"></fa-icon></router-link>
          </div>
          <div class="card-body">
            <span v-for="(ingr) in getMealIngredientList(meal)" :key="ingr.id" class="ingredient">{{ ingr.name }}</span>
          </div>
          <div class="card-footer">
            <button class="btn btn-primary" @click.stop="showPicker(meal)"><fa-icon icon="shopping-basket"></fa-icon><span>Add Ingredients To List</span></button>
          </div>
        </div>
      </div>
    </template>
    <template v-else>
      <div class="loading loading-xl"></div>
    </template>
  </section>
</template>

<script>
/*
  TODO:
    - Edit meal
      - Add/Remove ingredient
      - Change quantity
    - New meal
    - Delete meal
 */

import _ from 'lodash'

export default {
  name: 'meals',
  data () {
    return {
      editorOpen: false,
      pickerMeal: {}
    }
  },
  computed: {
  },
  methods: {
    closeEditor () {
      if (!this.editorOpen) {
        return
      }
      if (this.pickerMeal) {
        this.pickerMeal = {}
      }
      this.editorOpen = false
    },
    showPicker (meal) {
      this.pickerMeal = meal
      this.editorOpen = true
      window.scrollTo(0, 0)
    },
    getMealIngredientList (meal) {
      return _.sortBy(_.map(meal.ingredients, (i) => {
        i.name = `Unknown item (${i.itemId})`
        const item = this.getItemForId(i.itemId)
        if (item) {
          i.name = item.name
          i.notes = item.notes
          i.item = item
          i.storeList = _.map(item.storeIds, sId => this.getStoreForId(sId))
        }
        return i
      }), i => i.name.toLowerCase())
    }
  },
  beforeRouteEnter (to, from, next) {
    next(self => {
      self.setPageMeta(to.meta)
    })
  },
  created () {
    this.verifySignedIn()
  }
}
</script>

<style lang="scss">
  @import '../assets/_vars';

  #sl-meals {
    .card {
      color: $darkest-color;
      border: none;
      margin-bottom: 0.5rem;

      .card-header {
        display: flex;
        flex-direction: row;
        align-items: center;
        justify-content: space-between;
      }

      .ingredient {
        color: $primary-color;
        & + .ingredient:before {
          content: ", "
        }
      }

      .card-footer {
      }
    }
  }
</style>
